import React, { useEffect, useMemo, useRef, useState } from "react";
import styled, { css } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../store";
import { getTop5NewBornNameWordsByYearInfo } from '../slices/storeSlice';
import { useShallowEqualSelector } from "../modules/hooks"
import globalValues from "../store/globalValues";

//region style
const Subtitle = styled.p`
    text-align: center;
    font-weight: bold;
    color: #064645;

    ${(props) => {

      if (props.theme.isMobile || props.theme.isTablet) {
        return css`
          margin-top:45px;
          margin-bottom: 16px;
          font-size: 40px;
          `;
      }
      else {
        return css`
        margin-top: 150px;
        margin-bottom: 45px;
        font-size: 50px;
          `;
      }
    }}

`;
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-top: 60px;
  margin-bottom: 55px;
`;

const Column = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Part5BackGround = styled.div`
  width: 100%;
  border-radius: 30px;
  background: #cae7e2;

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        padding: 10px;
        `;
    }
    else {
      return css`
      height: 970px;
        `;
    }
  }}
  
`;

const Part5Dialog = styled.div`
  
  border-radius: 40px 40px 0 40px;
  background-color: white;
  position: relative;
  display: flex;
  color: #106b64;
  

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        flex-direction: column;
        width: 100%;
        border-radius: 40px;
        font-size: 22px;
        span{
          font-size: 40px;
          font-weight: bold;
          color: #1b969e;
        }
        `;
    }
    else {
      return css`
      margin-top: 85px;
      width: 900px;
      height: 248px;
      justify-content: center;
      align-items: center;
      font-size: 30px;
      span{
        font-size: 50px;
        font-weight: bold;
        color: #1b969e;
      }
        `;
    }
  }}

  `;

const Part5DialogLeftDiv = styled.div`

${(props) => {

  if (props.theme.isMobile || props.theme.isTablet) {
    return css`
      padding-top:30px;
      margin:10px 15px;
      div {
        margin-bottom: 10px;
      }
      `;
  }
  else {
    return css`
    display: flex;
    flex-direction: column;
    padding-right: 50px;
    div{
      margin-bottom:24px;
    }
      `;
  }
}}





  `;

const Part5DialogRightDiv = styled.div`

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      margin:15px;
      border-top: 2px dashed rgb(135,180,177);
      padding:20px 0 10px 0;
      div {
        margin-bottom: 10px;
      }
        `;
        
    }
    else {
      return css`
      padding-left: 55px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      border-left: 2px dashed rgb(135,180,177);
    
      div {
        margin-bottom: 24px;
      }
    
        `;
    }
  }}
  

  `;

const Part5YellowBottle = styled.div`
  background-image: url("${process.env.PUBLIC_URL}/images/05-yellow-bottle.png");
  background-size: cover;
  
  color: rgb(28,149,158);
  font-weight: bold;
  margin: 0 42px;
  position: relative;

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        width: 140px;
        height: 240px;
        font-size: 40px;

        div:first-child {
          margin-top: 12px;
          margin-left: 2px;
        }
      
        div:nth-child(2) {
          margin-left: 76px;
          margin-top: 98px;
        }

        `;
    }
    else {
      return css`
        width: 159px;
        height: 274px;
        font-size: 44px;

        div:first-child {
          margin-top: 12px;
          margin-left: 4px;
        }
      
        div:nth-child(2) {
          margin-left: 80px;
          margin-top: 120px;
        }

        `;
    }
  }}


  `;

const Part5BottleNumber = styled.div`
  margin-top: 10px;
  color: rgb(101,177,165);
  font-size: 18px;

  span {
    font-size: 14px;
  }

  `;

const Part5GreenBottle = styled.div`
  background-image: url("${process.env.PUBLIC_URL}/images/05-green-bottle.png");
  background-size: cover;
  font-size: 38px;
  color: rgb(45,119,106);
  font-weight: bold;
  margin: 0 8px;
  position: relative;
  ${(props) => {
    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        width: 72px;
        height: 123px;

        div:first-child {
          margin-top: 4px;
          font-size: 22px;
        }

        div:nth-child(2) {
          margin-left: 32px;
          margin-top: 48px;
          color: white;
          font-size: 32px;
        }

        `;
    }
    else {
      return css`
        width: 124px;
        height: 212px;

        div:first-child {
          margin-top: 10px;
          margin-left: 2px; 
          font-size: 30px;
        }

        div:nth-child(2) {
          margin-left: 58px;
          margin-top: 86px;
          color: white;
        }

        `;
    }
  }}

  `;

const Part5DialogTriangle = styled.div`
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 45px 0 0 45px;
    border-color: transparent transparent transparent #ffffff;
    position: absolute;
    bottom: 0;
    right: -45px;
    ${(props) => {
      if (props.theme.isMobile || props.theme.isTablet) {
        return css`
          display: none;
        `
      }
    }}
`;

const Part5DialogSmileFace = styled.div`
  background-image: url("${process.env.PUBLIC_URL}/images/02-dialog-smile.png");
  border-radius: 0 40px 40px 0;
  width: 64px;
  height: 64px;
  background-size: cover;
  position: absolute;
  top: 0;
  right: 0;
`;

const YearSelecterContainer = styled.select`
  margin: 0 5% 16px 5%;
  width: 90%;
  height: 48px;
  border-radius: 10px;
  border: none;
  font-size: 18px;
  font-weight: bold;
  padding-left: 32px;
  background: url("${process.env.PUBLIC_URL}/images/arrow.png") no-repeat scroll right center white;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  :focus-visible {
    outline: 2px dashed #cae7e2;
    border-radius: 10px;
  }
`;

const YearSelecterText = styled.p`
  color: #106b64;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
`;

//endregion

function Part5(props: any) {
  const isMobile: any = useSelector((state: RootState) => state.storeSlice.isMobile);
  const isTablet: any = useSelector((state: RootState) => state.storeSlice.isTablet);
  const dispatch = useDispatch();
  const MIN = globalValues.minYear;
  const MAX = globalValues.maxYear;

  const YearSelecter = () => {
    const [value, setValue] = useState(MAX);
    const firstUpdate = useRef(true);

    useMemo(() => {
      if (firstUpdate.current) {
        firstUpdate.current = false;
        return;
      }

      dispatch(getTop5NewBornNameWordsByYearInfo({ year: value }));
    }, [value])

    const Options = () => {
      let Result = [];
      for (let i = MAX; i >= MIN; i--) {
        Result.push(
          <option key={i} value={i}>{i}</option>
        );
      }
      return (
        <>
          {Result}
        </>
      );
    }

    return (
      <>
        <YearSelecterText>請選擇年份</YearSelecterText>
        <YearSelecterContainer value={value} onChange={e => setValue(parseInt(e.target.value))}>
          <Options />
        </YearSelecterContainer>
      </>

    )

  }

  const YearSilder = () => {
    const StepPerMove = 945 / (MAX - MIN);
    const [move, setMove] = useState(0);
    const [value, setValue] = useState(MAX);
    const [yearNeedtoGet, setYearNeedtoGet] = useState(MAX);
    const firstUpdate = useRef(true);

    useEffect(() => {
      changePosition();
    }, [value]);

    const changePosition = () => {
      setMove(StepPerMove * (MAX - value));
    };

    const changeYear = (event: React.ChangeEvent<HTMLInputElement>) => {
      setValue(parseInt(event.target.value));
    };

    useMemo(() => {
      if (firstUpdate.current) {
        firstUpdate.current = false;
        return;
      }

      dispatch(getTop5NewBornNameWordsByYearInfo({ year: value }));
    }, [value])

    const getData = () => {
      setYearNeedtoGet(value)
    }

    return (
      <>
        <div className="sliderYearDiv"><span style={{ right: `${move}px` }} className="SilderYearText">{value}</span></div>
        <div className="sliderContainer">
          <div>
            <input
              type="range"
              className="slider"
              min={MIN}
              max={MAX}
              value={value}
              step="1"
              onInput={changeYear}
              onMouseUp={getData}
              onKeyUp={getData}
            />
          </div>
        </div>
        <div className="sliderYearFromTo">
          <p>{MIN}</p>
          <p>{MAX}</p>
        </div>
      </>
    );
  };

  const Dialog =()=>{
    const generalInfo: any = useShallowEqualSelector((state: RootState) => state.storeSlice.generalInfo);
    const [topNewBornNameWord_Words, setTopNewBornNameWord_Words] = useState([]);
    const [top1999NewBornNameWord_Words, setTop1999NewBornNameWord_Words] = useState([]);

    useEffect(() => {
      if (generalInfo) {
        setTopNewBornNameWord_Words(generalInfo.topNewBornNameWord.map((m: any) => m.name));
        setTop1999NewBornNameWord_Words(generalInfo.top1999NewBornNameWord.map((m: any) => m.name));
      }
    }, [generalInfo]);

    if (isMobile || isTablet) {
      return (
          <Part5Dialog>
          <Part5DialogLeftDiv>
            <div>{globalValues.maxYear}年</div>
            <div>新生嬰兒最常用名字單字是</div>
            <span>{topNewBornNameWord_Words[0]}、{topNewBornNameWord_Words[1]}、{topNewBornNameWord_Words[2]}...</span>
          </Part5DialogLeftDiv>
          <Part5DialogRightDiv>
            <div>1999年</div>
            <div>則是</div>
            <span>{top1999NewBornNameWord_Words[0]}、{top1999NewBornNameWord_Words[1]}、{top1999NewBornNameWord_Words[2]}...</span>
          </Part5DialogRightDiv>
          <Part5DialogTriangle/>
          <Part5DialogSmileFace/>
        </Part5Dialog>
      )
    }
    else{
        return (
          <Part5Dialog>
          <Part5DialogLeftDiv>
            <div>{globalValues.maxYear}年</div>
            <div>新生嬰兒最常用名字單字是</div>
            <span>{topNewBornNameWord_Words[0]}、{topNewBornNameWord_Words[1]}、{topNewBornNameWord_Words[2]}...</span>
          </Part5DialogLeftDiv>
          <Part5DialogRightDiv>
            <div>1999年</div>
            <div>則是</div>
            <span>{top1999NewBornNameWord_Words[0]}、{top1999NewBornNameWord_Words[1]}、{top1999NewBornNameWord_Words[2]}...</span>
          </Part5DialogRightDiv>
          <Part5DialogTriangle/>
          <Part5DialogSmileFace/>
        </Part5Dialog>
      )
    }
  }

  function formatNumber(Number: any) {
    return String(Number).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  const LoopPart5NameWord =()=> {
    let Result = [];
    const [top5NewBornNameWordsByYear_Names, setTop5NewBornNameWordsByYear_Names] = useState([]);
    const [top5NewBornNameWordsByYear_Counts, setTop5NewBornNameWordsByYear_Counts] = useState(new Array(10).fill(0));
    const top5NewBornNameWordsByYearInfo: any = useSelector((state: RootState) => state.storeSlice.top5NewBornNameWordsByYearInfo);

    for (let i = 0; i < 5; i++) {
      if(i===0){
        Result.push(
          <Column key={i}>
            <Part5YellowBottle>
              <div>{i+1}</div>
              <div>{top5NewBornNameWordsByYear_Names[i]}</div>
            </Part5YellowBottle>
            <Part5BottleNumber>{formatNumber(top5NewBornNameWordsByYear_Counts[i])}<span>次</span></Part5BottleNumber>
          </Column>
        )
      }
      else{
        Result.push(
          <Column key={i}>
            <Part5GreenBottle>
              <div>{i+1}</div>
              <div>{top5NewBornNameWordsByYear_Names[i]}</div>
            </Part5GreenBottle>
            <Part5BottleNumber>{formatNumber(top5NewBornNameWordsByYear_Counts[i])}<span>次</span></Part5BottleNumber>
          </Column>
        )
      }
    }

    useEffect(() => {
      if (top5NewBornNameWordsByYearInfo) {
        setTop5NewBornNameWordsByYear_Names(top5NewBornNameWordsByYearInfo.top5NewBornNameWordsByYear.map((m: any) => m.name));
        setTop5NewBornNameWordsByYear_Counts(top5NewBornNameWordsByYearInfo.top5NewBornNameWordsByYear.map((m: any) => m.count));
      }
    }, [top5NewBornNameWordsByYearInfo]);


    if (isMobile || isTablet) {
      return (
        <>
          <Column>
            {Result[0]}
            <Container key={Math.random()}>
              {Result.slice(1)}
            </Container>
          </Column>
        </>
      )
    }
    else{
      return (
        <Container key={Math.random()}>
          {Result}
        </Container>
      )
    }
  }

  if (isMobile || isTablet) {
    return (
      <>
        <Subtitle>新生嬰兒<br/>最常用名字單字</Subtitle>
        <Part5BackGround>
          <Column>
            <Dialog/>
            <YearSelecter />
            <LoopPart5NameWord/>
          </Column>
        </Part5BackGround>
      </>
    )
  }
  else {
    return (
      <>
        <Subtitle>新生嬰兒最常用名字單字</Subtitle>
        <Part5BackGround>
          <Column>
            <Dialog/>
            <LoopPart5NameWord/>
          </Column>
          <YearSilder/>
        </Part5BackGround>
      </>
    )
  }
}

export default Part5;
